import { Controller } from "@hotwired/stimulus"
import { responseState } from "../field_sync_state"

// Enriches activity list items with pending photo state from IndexedDB.
//
// The activity view is server-rendered and only knows the response was saved
// to the server. If the user took photos that are still queued in pending_images,
// this controller changes the indicator from "Saved" (green) to "Photos pending" (amber).
//
// Values:
//   responseId -- the server response ID to check against pending_images.surveyableId
//
// Targets:
//   icon  -- the indicator circle (colour swap)
//   label -- the status text below the icon

export default class extends Controller {
  static targets = ["icon", "label"]
  static values  = { responseId: Number }

  async connect() {
    // Activity feed only enriches on queued PHOTOS, not on an unsubmitted form
    // row -- so we read the image counts off the shared selector and keep the
    // original "pending/failed image" gate exactly (ADR-0048 §1, W3.1).
    const { waitingImages, failedImages } = await responseState(this.responseIdValue)
    const count  = waitingImages + failedImages
    const failed = failedImages

    if (count === 0) return

    if (this.hasIconTarget) {
      const circle = this.iconTarget
      circle.className = circle.className
        .replace("bg-emerald-50", failed ? "bg-red-50" : "bg-amber-50")
      const svg = circle.querySelector("svg")
      if (svg) {
        svg.classList.remove("text-emerald-600")
        svg.classList.add(failed ? "text-red-600" : "text-amber-500")
      }
    }

    if (this.hasLabelTarget) {
      const lbl = this.labelTarget
      lbl.textContent = failed ? "Photo failed" : "Photos pending"
      lbl.className = lbl.className
        .replace("text-emerald-600", failed ? "text-red-600" : "text-amber-500")
    }
  }
}
